import { query } from '../../globalUtils/api';
import wtbFilterQuery from './wtbFilters.gql';
import wtbResults from './wtbResults.gql';
import intlResults from './intlReps.gql';

export const getData = async () => {
  const { internationalLocator, wtbFilters, ...rest } = await query(
    wtbFilterQuery
  );

  // inject United States for select
  internationalLocator.push({
    id: '0',
    name: 'United States',
    rep: null
  });

  // sort the array
  internationalLocator.sort((a, b) => (a.name > b.name) ? 1 : -1);

  return {
    internationalLocations: internationalLocator,
    roleOptions: wtbFilters,
    ...rest
  };
};

export const getResults = async queryData => {
  if (queryData.isInternational) {
    const { internationalLocation } = await query(intlResults, {
      variables: queryData.variables
    });
    return internationalLocation.reps.map(rep => {
      const result = {
        ...rep,
        companyName: rep.company
      };
      delete result.company;
      return result;
    });
  }

  const { repWtb } = await query(wtbResults, {
    variables: queryData.variables
  });
  return repWtb;
};

export const transformResults = results =>
  results.map((r, index) => ({
    show: !index > 0,
    ...r
  }));
